import { SET_VALUES, CLEAR_VALUES } from 'actions/types'

const initial = {
  first_name: '',
  last_name: '',
  roster_idx: '',
  cart: [],
}

export default (state = initial, action) => {
  switch (action.type) {
    case SET_VALUES:
      return {
        ...state,
        ...action.values,
      }
    case CLEAR_VALUES:
      return {
        ...initial,
      }
    default:
      return state
  }
}
